import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { Dialog, DialogTitle, IconV2, Typography } from "@bookips/sds";
import { useEffect } from "react";
import { getPassInfoSections } from "./getPassInfoSections";
import PassInfoDialogBody from "./PassInfoDialogBody";
import PassInfoDialogFooter from "./PassInfoDialogFooter";
/** 판별 유니온을 섹션 파생 입력으로 옮긴다 (mode 별로 동반 데이터가 다름) */ const toSectionInput = (props)=>{
    const { pass  } = props;
    if (props.mode === "owned") return {
        mode: "owned",
        pass,
        ticket: props.ticket
    };
    return {
        mode: "purchase",
        pass
    };
};
/** mixpanel 'Membership Id' — 보유 인스턴스 식별자. 구매 모드는 인스턴스가 없어 undefined */ const toMembershipId = (props)=>props.mode === "owned" ? props.ticket.membershipId : undefined;
const PassInfoDialog = (props)=>{
    const { isOpen , onClose , pass , mode , position , primaryLabel , onPrimary , onUsageGuide  } = props;
    const membershipId = toMembershipId(props);
    const sections = getPassInfoSections(toSectionInput(props));
    // MX-596 — 다이얼로그 노출 시 'Popup Viewed' 발사. isOpen=true 전이 시점 1회만 발사 (후속 prop 변경 재발사 방지)
    useEffect(()=>{
        if (!isOpen) return;
        mixpanelEvent("Popup Viewed", {
            Position: position,
            "Popup Type": "이용권 상세 다이얼로그",
            "Popup Title": pass.title,
            "Membership Product Id": pass.id,
            "Membership Id": membershipId,
            "Membership Category": pass.category
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ _jsx(Dialog, {
        open: isOpen,
        onOpenChange: (o)=>!o && onClose(),
        scroll: true,
        classes: {
            contentWrapper: cn("w-[520px] max-w-[calc(100vw-40px)] max-h-[calc(100vh-144px)] gap-2", // 모바일 bottom-sheet 모양 (SDS BottomSheet 부재 — Tailwind override 로 처리)
            // !translate-* 는 SDS Dialog 의 기본 중앙 정렬 transform 을 reset 하기 위한 것.
            // CSS animation spec 상 keyframe transform 이 활성 중에는 declared !important 보다 우선 적용되므로 슬라이드와 충돌하지 않음.
            // iOS Chrome 하단 탭바에 가려지지 않도록 svh 사용 (vh 는 chrome 영역 포함한 이론적 최대값이라 잘림 발생)
            "max-sm:!w-full max-sm:!max-w-full max-sm:!max-h-[calc(100svh-48px)]", "max-sm:!fixed max-sm:!bottom-0 max-sm:!left-0 max-sm:!top-auto", "max-sm:!translate-x-0 max-sm:!translate-y-0", "max-sm:!rounded-b-none max-sm:!rounded-t-2xl", // 모바일 bottom-sheet 슬라이드 애니메이션 (Radix data-state 연동)
            "max-sm:data-[state=open]:animate-slide-in-from-bottom", "max-sm:data-[state=closed]:animate-slide-out-to-bottom"),
            content: "flex flex-col min-h-0 pb-7"
        },
        title: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-start justify-between gap-2 px-5 pt-7 sm:hidden",
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "h6",
                            className: "text-primary flex-1 break-words",
                            children: pass.title
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            "aria-label": "닫기",
                            onClick: onClose,
                            className: "mt-0.5 shrink-0",
                            children: /*#__PURE__*/ _jsx(IconV2.Close, {
                                size: "sm"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "hidden items-start justify-between gap-2 px-7 pt-7 sm:flex",
                    children: [
                        /*#__PURE__*/ _jsx(DialogTitle, {
                            title: pass.title,
                            className: "flex-1 break-all"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            "aria-label": "닫기",
                            onClick: onClose,
                            className: "mt-1 block size-6 shrink-0 cursor-pointer focus:outline-none",
                            children: /*#__PURE__*/ _jsx(IconV2.Close, {
                                size: "sm"
                            })
                        })
                    ]
                })
            ]
        }),
        footer: /*#__PURE__*/ _jsx(PassInfoDialogFooter, {
            pass: pass,
            membershipId: membershipId,
            mode: mode,
            position: position,
            primaryLabel: primaryLabel,
            onPrimary: onPrimary,
            onUsageGuide: onUsageGuide
        }),
        children: /*#__PURE__*/ _jsx(PassInfoDialogBody, {
            sections: sections
        })
    });
};
export default PassInfoDialog;
